// Sidebar.js
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import {
  UserOutlined,
  RetweetOutlined,
  ContactsOutlined,
  RiseOutlined,
  SnippetsOutlined,
  ApartmentOutlined,
  FileDoneOutlined,
  FormOutlined,
  SolutionOutlined,
  IdcardOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  MailOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";

const Sidebar = ({ collapsed }) => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (["courses", "enrollment"].includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={250}
      style={{ height: "100vh", position: "sticky" }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        triggerSubMenuAction="hover"
      >
        <Menu.Item key="/director-dashboard" icon={<UserOutlined />}
         title="Director Dashboard" 
        >
          <Link to="/director-dashboard" className="text-decoration-none">
            Director Dashboard
          </Link>
        </Menu.Item>

        <Menu.Item key="/employee-exchange" icon={<RetweetOutlined />}
          title="Employee Exchange" 
        >
          <Link to="/employee-exchange" className="text-decoration-none">
            Employee Exchange
          </Link>
        </Menu.Item>

        <Menu.Item key="/skill-development" icon={<RiseOutlined />}
         title="Skill Development" 
        >
          <Link to="/skill-development" className="text-decoration-none">
            Skill Development
          </Link>
        </Menu.Item>

        {/* Courses Menu */}
        <Menu.SubMenu key="courses" icon={<SnippetsOutlined />} title="Courses">
          <Menu.Item key="/courses/manage-course" icon={<ApartmentOutlined />}
            title="Manage Courses" 
          >
            <Link to="/courses/manage-course" className="text-decoration-none">
              Manage Courses
            </Link>
          </Menu.Item>

          <Menu.Item key="/courses/add-new-course" icon={<FileDoneOutlined />}
           title="Add New Courses" 
          >
            <Link to="/courses/add-new-course" className="text-decoration-none">
              Add New Courses
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/courses/course-categories"
            icon={<ApartmentOutlined />}
            title="Course Category" 
          >
            <Link
              to="/courses/course-categories"
              className="text-decoration-none"
            >
              Course Category
            </Link>
          </Menu.Item>

          <Menu.Item key="/courses/coupons" icon={<SnippetsOutlined />}
            title="Coupons"
          >
            <Link to="/courses/coupons" className="text-decoration-none">
              Coupons
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Enrollment Menu */}
        <Menu.SubMenu
          key="enrollments"
          icon={<SnippetsOutlined />}
          title="Enrollments"
        >
          <Menu.Item key="/enrollments/course" icon={<ApartmentOutlined />}
           title="Course Enrollment" 
          >
            <Link to="/enrollments/course" className="text-decoration-none">
              Course Enrollment
            </Link>
          </Menu.Item>

          <Menu.Item
            key="enrollments/enroll-history"
            icon={<FileDoneOutlined />}
            title="Enrollment History" 
          >
            <Link
              to="/enrollments/enroll-history"
              className="text-decoration-none"
            >
              Enrollment History
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Users Menu */}
        <Menu.SubMenu key="users" icon={<SnippetsOutlined />} title="Users">
          <Menu.SubMenu key="admins" icon={<SnippetsOutlined />} title="Admins">
            <Menu.Item key="/users/admin-users" icon={<UserOutlined />}
             title="Manage Admins" 
            >
              <Link to="/users/admin-users" className="text-decoration-none">
                Manage Admins
              </Link>
            </Menu.Item>

            <Menu.Item key="/users/admin-users/add" icon={<UserOutlined />}
              title="Add New Admin" 
            >
              <Link
                to="/users/admin-users/add"
                className="text-decoration-none"
              >
                Add New Admin
              </Link>
            </Menu.Item>
          </Menu.SubMenu>

          <Menu.SubMenu
            key="instructors"
            icon={<SnippetsOutlined />}
            title="Manage Instructors"
          >
            <Menu.Item key="/users/admin-instructors" icon={<UserOutlined />}>
              <Link
                to="/users/admin-instructors"
                className="text-decoration-none"
              >
                Manage Instructors
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/users/admin-instructors/add"
              icon={<UserOutlined />}
              title="Add New Instructor"
            >
              <Link
                to="/users/admin-instructors/add"
                className="text-decoration-none"
              >
                Add New Instructor
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/users/admin-instructors/payouts"
              icon={<UserOutlined />}
              title="Payouts"
            >
              <Link
                to="/users/admin-instructors/payouts"
                className="text-decoration-none"
              >
                Payouts
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/users/admin-instructors/settings"
              icon={<UserOutlined />}
              title="Instructor Settings"
            >
              <Link
                to="/users/admin-instructors/settings"
                className="text-decoration-none"
              >
                Instructor Settings
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/users/admin-instructor-applications"
              icon={<UserOutlined />}
              title="Applications"
            >
              <Link
                to="/users/admin-instructor-applications"
                className="text-decoration-none"
              >
                Applications
              </Link>
            </Menu.Item>
          </Menu.SubMenu>

          <Menu.Item key="/users/admin-students" icon={<UserOutlined />}
           title="Manage Students"
          >
            <Link to="/users/admin-students" className="text-decoration-none">
              Manage Students
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Messages Menu */}
        <Menu.Item key="/messages" icon={<MessageOutlined />}
         title="Messages"
        >
          <Link to="/messages" className="text-decoration-none">
            Messages
          </Link>
        </Menu.Item>

        {/* Approvals Menu with Nested Submenu */}
        {/* <Menu.SubMenu key="approvals" icon={<FileDoneOutlined />} title="Approvals">
            <Menu.Item key="/enrollment/approvals/user" icon={<IdcardOutlined />}>
              <Link to="/enrollment/approvals/user" className="text-decoration-none">
                User Approvals
              </Link>
            </Menu.Item>

            <Menu.Item key="/enrollment/approvals/employee" icon={<TeamOutlined />}>
              <Link to="/enrollment/approvals/employee" className="text-decoration-none">
                Employee Approvals
              </Link>
            </Menu.Item>
          </Menu.SubMenu> */}
        {/* </Menu.SubMenu> */}

        <Menu.Item key="/contact" icon={<ContactsOutlined />}
         title="Contact"
        >
          <Link to="/contact" className="text-decoration-none">
            Contact
          </Link>
        </Menu.Item>

        {/* newsletter menu */}
        <Menu.SubMenu
          key="newsletter"
          icon={<SnippetsOutlined />}
          title="Newsletter"
        >
          <Menu.Item
            key="/newsletter/all-newsletters"
            icon={<ApartmentOutlined />}
            title="All newsletter"
          >
            <Link
              to="/newsletter/all-newsletters"
              className="text-decoration-none"
            >
              All newsletter
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/newsletter/subscribed-users"
            icon={<ApartmentOutlined />}
            title="Subscribed user"
          >
            <Link
              to="/newsletter/subscribed-users"
              className="text-decoration-none"
            >
              Subscribed user
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Blog Menu */}
        <Menu.SubMenu key="blogs" icon={<SnippetsOutlined />} title="Blogs">
          <Menu.Item key="/blogs/all-blogs" icon={<ApartmentOutlined />}
           title="All Blogs"
          >
            <Link to="/blogs/all-blogs" className="text-decoration-none">
              All Blogs
            </Link>
          </Menu.Item>

          <Menu.Item key="/blogs/pending-blogs" icon={<FileDoneOutlined />}
           title="Pending Blogs"
          >
            <Link to="/blogs/pending-blogs" className="text-decoration-none">
              Pending Blogs
            </Link>
          </Menu.Item>

          <Menu.Item key="/blog/category" icon={<ApartmentOutlined />}
           title="Blog Category"
          >
            <Link to="/blog/category" className="text-decoration-none">
              Blog Category
            </Link>
          </Menu.Item>

          <Menu.Item key="/blog/settings" icon={<SnippetsOutlined />}
           title="Blog settings"
          >
            <Link to="/blog/settings" className="text-decoration-none">
              Blog settings
            </Link>
          </Menu.Item>
        </Menu.SubMenu>

        {/* Addons Menu */}
        <Menu.Item key="/addons/all-addons" icon={<ContactsOutlined />}
         title="Addons"
        >
          <Link to="/addons/all-addons" className="text-decoration-none">
            Addons
          </Link>
        </Menu.Item>

        {/* Settings Menu */}
        <Menu.SubMenu
          key="settings"
          icon={<SnippetsOutlined />}
          title="Settings"
        >
          <Menu.Item
            key="/settings/system-settings"
            icon={<ApartmentOutlined />}
            title="System settings"
          >
            <Link
              to="/settings/system-settings"
              className="text-decoration-none"
            >
              System settings
            </Link>
          </Menu.Item>

          {/* <Menu.Item key="/settings/website-settings" icon={<ApartmentOutlined />}>
            <Link to="/settings/website-settings" className="text-decoration-none">
              Website settings
            </Link>
          </Menu.Item> */}

          <Menu.Item
            key="/settings/drip-content-settings"
            icon={<ApartmentOutlined />}
            title="Drip content settings"
          >
            <Link
              to="/settings/drip-content-settings"
              className="text-decoration-none"
            >
              Drip content settings
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/settings/wasabi-storage-settings"
            icon={<ApartmentOutlined />}
            title="Wasabi storage settings"
          >
            <Link
              to="/settings/wasabi-storage-settings"
              className="text-decoration-none"
            >
              Wasabi storage settings
            </Link>
          </Menu.Item>

          <Menu.Item key="/settings/zoom-settings" icon={<ApartmentOutlined />}
           title="Zoom live class settings"
          >
            <Link to="/settings/zoom-settings" className="text-decoration-none">
              Zoom live class settings
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/settings/bbb-live-class-settings"
            icon={<ApartmentOutlined />}
            title="Bbb live class settings"
          >
            <Link
              to="/settings/bbb-live-class-settings"
              className="text-decoration-none"
            >
              Bbb live class settings
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/settings/notification-settings"
            icon={<ApartmentOutlined />}
            title="Notification settings"
          >
            <Link
              to="/settings/notification-settings"
              className="text-decoration-none"
            >
              Notification settings
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/settings/social-settings"
            icon={<ApartmentOutlined />}
            title="Social login"
          >
            <Link
              to="/settings/social-settings"
              className="text-decoration-none"
            >
              Social login
            </Link>
          </Menu.Item>

          <Menu.Item key="/settings/custom-page" icon={<ApartmentOutlined />}
           title="Custom page builder"
          >
            <Link to="/settings/custom-page" className="text-decoration-none">
              Custom page builder
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
